import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AllUniformAddPopup from "../../../../components/modelpopup/AllUniformAddPopup";

import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import UniformListFilter from "../components/UniformListFilter";
import { Table, Pagination,  } from "antd";
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";
import {formatDateHandler2} from "utils/common"

import { SkeltonLoader } from "components/skeltonLoader";
import UniformsFilterDrawer from "components/Drawer/uniformsFilterDrawer";
import { useUniform } from "../context/uniformContext";
import Image from "components/Image"
import {  toast, Bounce } from 'react-toastify';
import { Button } from "components/Button";

//import { deleteUniformApi } from "api/services/uniforms";


const AllUniforms = () => {
  const {
    loading,
    setLoading,
    searchText,
    uniformData,
    view,
    setView, 
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleUniformDetailPage,
    handleDateChange,

    uniformModal, setUniformModal,
    setSelectedUniform, selectedUniform,
    getUniformList   
  } = useUniform();

  const [deleteModal, setDeleteModal] = useState(false)


  const  handleEditUniform = (item) => {    
    setUniformModal(true)
  }

  const  handleDeleteUniform = (item) => {    
    //setUniformModal(true)
  }

  const displayUniformPositions = (uniformPos = []) => {
    const positions = uniformPos || [];
    const visiblePositions = positions.slice(0, 2); 
    const extraPositionCount = positions.length - 2; 

    return (
      <div className="d-flex flex-wrap">
       
        {visiblePositions.map((pos, index) => (
          <span
            key={index}
            className="badge badge-soft-primary px-3 py-1 m-1"
            style={{
              backgroundColor: "#f0f0f0", 
                    
              fontSize: "14px",   
            }}
            title={pos.name} 
          >
            {pos.name}
          </span>
        ))}

     
        {extraPositionCount > 0 && (
          <span
            className="badge px-3 py-1 m-1"
            style={{
              backgroundColor: "#f0f0f0",
              color: "#333",
              borderRadius: "12px",
              fontSize: "14px",
            }}
            title={positions.slice(2).map(dept => dept.name).join(", ")} 
          >
            +{extraPositionCount}
          </span>
        )}
      </div>
    );
  }

  const displayUniformColor = (colorVal, isText) => {
    return (
      <div
      className="d-flex align-items-center"
      style={{ gap: "8px" }} 
    >
      
      <span
        style={{
          backgroundColor: colorVal,
          border: "1px solid #ccc",
          width: "24px",
          height: "24px",
          borderRadius: "4px", 
          display: "inline-block",
        }}
      ></span>
      
   
     {isText ?  <span
        style={{
          display: "flex",
          alignItems: "center",
          height: "24px", 
          fontSize: "14px",
        }}
      >
        {colorVal}
      </span> : <></> }
    </div>
    )
   
  }

  const displayUniformSizes = (uniformsizes = []) => {
    if (!uniformsizes.length) return <span>-</span>;
  
    const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];
  
   
    const sortedSizes = uniformsizes
      .slice() 
      .sort((a, b) => 
        (sizeOrder.indexOf(a.code) !== -1 ? sizeOrder.indexOf(a.code) : sizeOrder.length) -
        (sizeOrder.indexOf(b.code) !== -1 ? sizeOrder.indexOf(b.code) : sizeOrder.length)
      );
  

    const visibleSizes = sortedSizes.slice(0, 3);
    const extraSizesCount = sortedSizes.length - 3;
  
    return (
      <div className="d-flex align-items-center">
        {/* Display first 3 sizes */}
        {visibleSizes.map((size, index) => (
          <span
            key={index}
            className="badge badge-soft-secondary px-2 py-1 mx-1"
            style={{
              borderRadius: "12px",
              fontSize: "14px",
            }}
            title={size.code} // Show size code on hover
          >
            {size.code}
          </span>
        ))}
  
        {/* Show +X more if there are more than 3 sizes */}
        {extraSizesCount > 0 && (
          <span
            className="badge px-2 py-1 mx-1"
            style={{
              backgroundColor: "#f0f0f0",
              color: "#333",
              borderRadius: "12px",
              fontSize: "14px",
            }}
            title={sortedSizes.slice(3).map(size => size.code).join(", ")} // Show all remaining sizes on hover
          >
            +{extraSizesCount} more
          </span>
        )}
      </div>
    );
  };


  const displayUniformGender = (uniformGender) => {
    return (
      <span className="badge badge-soft-primary d-flex align-items-center justify-content-center w-75" >
      <i className={`la la-${uniformGender === 'M' ? 'mars' : uniformGender === 'F' ? 'venus' : 'genderless'} me-1`}></i>
         {uniformGender === 'M' ? 'Male' : uniformGender === 'F' ? 'Female' : uniformGender === 'U' ? 'Unisex' : ''}
    </span>)
  }
  
  
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id, 
      defaultSortOrder: "ascend",
      render: (text, record) => (
        <span className="table-avatar">
          {record.id}
        </span>
      )      
    },
    {
      title: "Image",
      dataIndex:"image",
      render: (text,record, index) => (
        <>
           <a onClick={() => handleUniformDetailPage(record.id, index)} className="avatar">
            <Image src={record.image} type="user" style={{ objectFit: "cover" }} />
          </a>
        </>
      )
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: true,
      render: (text, record, index) => (
        <div className="table-avatar d-flex align-items-center">
       
          <a
            onClick={() => handleUniformDetailPage(record.id, index)}
            className="profile-split d-flex flex-column justify-content-center ms-2"
          >
            {record.name}
          </a>
        </div>
      ),
    },

    // {
    //   title: "Color",
    //   dataIndex: "color",
    //   sorter: true,
    //   render: (text, record) => (
    //     <> 
    //       {displayUniformColor(record?.color, true)}
    //     </>
    //   )
    // },
  
    {
      title: "Gender",
      dataIndex: "gender",
      sorter: true,
      render: (text, record) => (
        <> {displayUniformGender(record?.gender)} </>
      )
    },

    {
      title: "Sizes",
      dataIndex: "sizes",
      sorter: true,
      render: (text, record) => (
        <> 
          {displayUniformSizes(record?.sizes)} 
        </> 
      )

  
    },
  
    // {
    //   title: "positions",
    //   dataIndex: "positions",
    //   sorter: true,
    //   render: (text, record) => (
    //     <>
    //     {displayUniformPositions(record?.positions)}
    //     </>
    //   )
    // },

    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      render: (text, record) => (
        <>
     
          <span className={`badge ${record?.status ? "badge-primary" : "badge-warning"}`} 
          style={{ fontSize: "0.75rem", padding: "5px 10px", fontWeight: "bold" }}
        >
          {record.status ? "Active" : "Inactive"}
        </span>
        </>
      )   
    
    },

    


    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.description}
    //     </span>
    //   )   
    
    // },
    // {
    //   title: "Action",
    //   render: (text , record) => (
    //     <div className="dropdown dropdown-action text-end">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
          
    //         <Link
    //         onClick={()=>{
    //           setDeleteModal(true)
    //           setSelectedUniform(record)}}
    //           to="#"
    //           className="dropdown-item"             
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // }
    
  ];

  


  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {uniformData.map((record, index) => {
            const isWhiteColor = record?.color?.toLowerCase() === "#ffffff" || record?.color?.toLowerCase() === "white";
            const isActive = record?.status || false; 

            return (
              <div className="col-xxl-3 col-xl-4 col-md-6">
                <div
                  className="contact-grid p-3 border rounded d-flex position-relative"
                  style={{ minHeight: "220px", display: "flex", flexDirection: "row", alignItems: "stretch" }}
                >
                  
                  {/* Top-right Controls: Dropdown Menu */}
                  <div className="position-absolute top-0 end-0 d-flex align-items-center p-2">
                    {/* Dropdown Menu Button */}
                    <div className="dropdown">
                      <button
                        className="btn btn-link p-0"
                        type="button"
                        id={`dropdownMenu-${record.id}`}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="material-icons">more_vert</i>
                      </button>
                      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby={`dropdownMenu-${record.id}`}>
                        <li>
                          <a className="dropdown-item" href="#" onClick={() => handleEditUniform(record.id)}>
                            <i className="fa-solid fa-pencil m-r-5"></i> Edit
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item text-danger" href="#" onClick={() => handleDeleteUniform(record.id)}>
                            <i className="fa-regular fa-trash-can m-r-5"></i> Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Uniform Image */}
                  <div className="uniform-image" style={{ flex: "0 0 40%" }}>
                    <a onClick={() => handleUniformDetailPage(record.id, index)}>
                      {record?.image ? (
                        <img 
                          src={record.image} 
                          alt={record.name} 
                          className="rounded"
                          style={{ width: "100%", height: "180px", objectFit: "cover" }}
                        />
                      ) : (
                        <div 
                          className="no-image-placeholder d-flex align-items-center justify-content-center text-muted"
                          style={{ width: "100%", height: "180px", backgroundColor: "#f0f0f0", textAlign: "center", fontSize: "14px", fontWeight: "bold" }}
                        >
                          No Image Found
                        </div>
                      )}
                    </a>
                  </div>

                  {/* Uniform Details */}
                  <div className="ms-3 flex-grow-1 d-flex flex-column w-100">
                    
                    {/* Uniform Name with Ellipsis */}
                    <h5 className="name-user mb-2" 
                        style={{
                          whiteSpace: "nowrap", 
                          overflow: "hidden", 
                          textOverflow: "ellipsis", 
                          maxWidth: "calc(100% - 50px)", // Account for dropdown width
                          fontSize: "0.9rem" // Adjusted font size
                        }} 
                        title={record?.name}>
                      <a onClick={() => handleUniformDetailPage(record.id, index)}>{record?.name}</a>
                    </h5>

                    {/* Gender & Color */}
                    <div className="d-flex justify-content-between text-muted mb-2">
                      <span>{displayUniformGender(record?.gender)}</span>
                      
                      {/* Color Box with Border for White */}
                      <span 
                        className="color-box" 
                        style={{
                          backgroundColor: record?.color, 
                          width: "20px", 
                          height: "20px", 
                          borderRadius: "50%", 
                          display: "inline-block",
                          border: isWhiteColor ? "1px solid #ccc" : "none", 
                          position: "relative"
                        }}
                        title={record?.color || "Unknown Color"} 
                      />
                    </div>

                    {/* Department Details */}
                    <div className="text-muted mb-2">
                      {record?.positions.length 
                        ? displayUniformPositions(record?.positions) 
                        : <span className="badge badge-soft-primary" style={{ fontSize: "0.875rem", fontWeight: "normal" }}>Department N/A</span>
                      }
                    </div>

                    {/* Active Badge + Sizes */}
                    <div className="mt-auto d-flex align-items-center justify-content-between w-100">
                      
                      {/* Active Status Badge */}
                      <span 
                        className={`badge ${isActive ? "badge-primary" : "badge-secondary"}`} 
                        style={{ fontSize: "0.75rem", padding: "5px 10px", fontWeight: "bold" }}
                      >
                        {isActive ? "Active" : "Inactive"}
                      </span>

                      {/* Sizes */}
                      <div>{displayUniformSizes(record?.sizes)}</div>

                    </div>

                  </div>

                </div>
              </div>
            );
          })}
        </>
      );
    }
  };



  
  
  
  const reloadPage = () => {
    getUniformList()
  }
  
  
  
  



  const deleteHandler = (props) => {
    console.log(selectedUniform, "LLLLLLLL")
    // deleteUniformApi(selectedUniform?.id).then(res=>{
    //   toast.success('Uniform deleted successfully!', {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: false,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //     transition: Bounce,
    //     });
    //     getUniformList()
    //     setDeleteModal(false)
    // }).catch(e=>{
    //   toast.error('Error deleting uniform!', {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: false,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //     transition: Bounce,
    //     });
    // })
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
     
        
          <Breadcrumbs
           maintitle="Uniforms"
           title="Dashboard"
           subtitle="Uniforms"
           modal="#add_uniform"
           name="Add Uniform"
           view={view}
           setUniformModal={setUniformModal}
           setView={setView}  
           
          />



          <UniformListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search Uniforms"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          />



          {view == "grid" ? (
            <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="table-responsive">
                {/* <SearchBox pageSettings={pageSettings} setPageSettings={setPageSettings} /> */}
                <Table
                // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={uniformData}
                  rowKey={(record) => record.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}

      <AllUniformAddPopup getUniformList={getUniformList} setSelectedUniform={setSelectedUniform} setLoading={setLoading} selectedUniform={selectedUniform} loading={loading} reloadPage={reloadPage}  uniformModal={uniformModal} setUniformModal={setUniformModal} />
      {/* Delete Modal */}
      <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteHandler={deleteHandler} Name="Delete Record" />
        </div>
      </div>

  
    

      <UniformsFilterDrawer
          searchPlaceholder={"Search Uniforms"}
          showFilterDrawer={showFilterDrawer}
          handleFilterDrawer={handleFilterDrawer}
          handleFilterChange={handleFilterChange}
          filters={filters}
          handleInputChange={handleInputChange}
          handleApplyFilter={handleApplyFilter}
          filterLoading={filterLoading}
          handleDateChange={handleDateChange}
/>
      {/* Delete Modal */}
    </>
  );
};

export default AllUniforms;
